module.exports = __webpack_public_path__ + "static/profile-7a88128cd8dd8317244d1fe079cb18b2.png";